import { useSize } from 'ahooks'
import { useEffect, useRef, useState } from 'react'

export default function usePageSizeByRef(itemHeight: number, defaultPageSize = 10, minPageSize = 5) {
  const [pageSize, setPageSize] = useState(defaultPageSize)
  const ref = useRef(null)
  const size = useSize(ref)

  useEffect(() => {
    if (!size) {
      return
    }
    const { height } = size
    const pageSize = Math.floor(height / itemHeight)

    setPageSize(Math.max(pageSize, minPageSize))
  }, [size])

  return { ref, size, pageSize }
}
